<!-- @format -->
<template>
	<div class="res-list">
		<pc-table-header-v2
			:key="`${resItem.resCode}${moreSearchList.length}${isKeyList.length}`"
			:is-more-search="true"
			:is-more-columns="true"
			:is-more-export="true"
			:more-search-list="moreSearchList"
			:more-column-list="moreSearchList"
			:more-export-list="moreSearchList"
			:default-search-list="isKeyList"
			:default-column-list="isKeyList"
			:default-export-list="defaultExportList"
			:name="name"
			@on-search="onSearch"
			@on-export="onExport"
		>
			<template #extra>
				<slot name="front-button"> </slot>
				<template v-if="!disabled">
					<pc-pop-confirm title="请确认是否删除" :disabled="!selectIds.length" @confirm="onDelete">
						<template #reference>
							<el-button type="danger" link icon="Delete" :disabled="!selectIds.length"> 删除 </el-button>
						</template>
					</pc-pop-confirm>
					<el-button type="primary" :disabled="!widgetDatas.length" link icon="Plus" @click="onClickItem('add')">
						添加配置
					</el-button>
					<el-button type="primary" link icon="Plus" @click="importClick"> 导入 </el-button>
				</template>
			</template>

			<template #search-cpt="item">
				<component
					:is="getWidgetName(item.type)"
					:options="item.options"
					:is-show-default="false"
					:model-value="item.modelValue"
					@update:model-value="item['update:modelValue']"
				/>
			</template>

			<template #search-item="scope">
				<template v-if="scope.item.isKey === '1'">
					<svg-icon name="key" />
				</template>
				{{ scope.item.label }}
			</template>

			<template #column-item="scope">
				<template v-if="scope.item.isKey === '1'">
					<svg-icon name="key" />
				</template>
				{{ scope.item.label }}
			</template>

			<template #export-item="scope">
				<template v-if="scope.item.isKey === '1'">
					<svg-icon name="key" />
				</template>
				{{ scope.item.label }}
			</template>
		</pc-table-header-v2>
		<pc-table-v2
			ref="resTable"
			:key="`${resItem.resCode}${moreSearchList.length}${isKeyList.length}`"
			:loading="tableLoading"
			:data="tableData.data"
			:total="tableData.total"
			:max-height="400"
			row-key="objectid"
			border
			class="res-list-table"
			:name="name"
			v-bind="tableProps"
			@page-change="tableChange"
		>
			<el-table-column type="selection" width="45" />
			<el-table-column prop="resName" label="名称" fixed min-width="200" show-overflow-tooltip>
				<template #default="scope">
					<el-button type="primary" link @click="() => onClickItem('read', scope)">
						{{ scope.row.resName }}
					</el-button>
				</template>
			</el-table-column>
			<el-table-column prop="createdTime" label="创建时间" min-width="200" />
			<el-table-column prop="updatedTime" label="更新时间" min-width="200" />

			<template #column-header="scope">
				<template v-if="getItem(scope.column.property)?.isKey === '1'">
					<svg-icon name="key" />
				</template>
				{{ scope.column.label }}
			</template>
			<template #column="scope">
				<template v-if="getItem(scope.column.property)?.isKey === '1'">
					<template v-if="showComponentValueList.includes(getItem(scope.column.property)!.type)">
						<el-button type="primary" link @click="() => onClickItem('read', scope)">
							<template v-if="showComponentValueList.includes(getItem(scope.column.property)!.type)">
								<component
									:is="getWidgetName(getItem(scope.column.property)!.type)"
									:is-show-value="true"
									:model-value="scope.row.fieldMap[scope.column.property]"
									:options="getItem(scope.column.property)!.options"
								/>
							</template>
						</el-button>
					</template>
					<template v-else>
						<el-button type="primary" link @click="() => onClickItem('read', scope)">
							{{ scope.row.fieldMap[scope.column.property] }}
						</el-button>
					</template>
				</template>

				<template v-else-if="showComponentValueList.includes(getItem(scope.column.property)!.type)">
					<component
						:is="getWidgetName(getItem(scope.column.property)!.type)"
						:is-show-value="true"
						:model-value="scope.row.fieldMap[scope.column.property]"
						:options="getItem(scope.column.property)!.options"
					/>
				</template>

				<template v-else>
					{{ scope.row.fieldMap[scope.column.property] }}
				</template>
			</template>
		</pc-table-v2>

		<pcp-res-detail
			v-model:type="drawer.type"
			:item="drawer.item"
			:widget-datas="widgetDatas"
			:disabled="disabled"
			:params="props.params?.bussinessCode ? { bussinessCode: props.params?.bussinessCode } : {}"
			:resource-config="resourceConfig"
			@on-add="onAdd"
			@on-edit="onEdit"
		/>

		<pc-import v-model="importVisible" accept=".xls, .xlsx" title="导入" :limit="1" @on-import="onImport">
			<template #top>
				<p>
					<el-button link size="small" :loading="exportLoading" type="primary" @click="onExportTemplate">
						导出模版
					</el-button>
				</p>
			</template>
		</pc-import>
	</div>
</template>

<script setup lang="ts">
	import dayjs from 'dayjs';
	import { download, useRequest } from '@power/runtime-vue3';
	import PcpResDetail from './pcp-res-detail.vue';
	import PcTableHeaderV2 from '@/components/pc-table-v2/pc-table-header.vue';
	import PcImport from '@/components/pc-import/index.vue';
	import { getWidgetName } from '@/components/Drag/components/Form/Components/index.ts';
	import { PcTableV2, PcPopConfirm } from '@/components';
	import {
		getModel,
		getResObjectList,
		exportResObjectList,
		delResObject,
		addResObject,
		editResObject,
		importResource,
		exportTemplate,
		getBussinessList,
	} from '@/api/resource';

	// 用组件展示对应列的数据列表
	const showComponentValueList = ['select', 'radio', 'checkbox'];
	// interface
	interface Drawer {
		item: any; // 当前选中的数据
		type: 'none' | 'edit' | 'add' | 'read'; // 点击类型
	}

	const initDrawer = (): Drawer => ({
		item: {},
		type: 'none',
	});

	interface Params {
		resCode: string;
		resName?: string;
		pageNum?: number;
		pageSize?: number;
		fieldMap?: Record<string, any>;
	}

	interface Props {
		resItem: Record<string, any>;
		disabled?: boolean;
		params?: Record<string, any>; // 可以需要预设的参数
		name: string;
		onlyOneOpenDetail?: boolean;
		tableProps?: any;
	}

	const props = withDefaults(defineProps<Props>(), {
		disabled: false,
	});

	const emits = defineEmits(['callback']);

	// 请求table参数
	const INIT_PARAMS = (): Params => ({
		resCode: '',
		resName: '',
		pageNum: 1,
		pageSize: 10,
		fieldMap: {},
	});

	//导入
	//对话框关闭
	const importVisible = ref(false);

	const exportLoading = ref<boolean>(false);

	// state
	// 请求列表参数
	const params1 = ref<Params>(INIT_PARAMS());

	// table实例
	const resTable = ref<InstanceType<typeof PcTable> | null>(null);

	// table数据
	const tableData = ref({
		data: [],
		total: 0,
	});

	// drawer详情数据
	const drawer = ref<Drawer>(initDrawer());

	// 模版数据
	const widgetDatas = ref<any[]>([]);

	const resourceConfig = ref<{
		relationCompute: '0' | '1';
		ifRecordHis: '0' | '1';
	}>({
		relationCompute: '0',
		ifRecordHis: '0',
	});

	// 获取主项字段,提供给更多筛选，定制列，导出使用
	const moreSearchList = computed(() =>
		widgetDatas.value
			.filter((item) => !item.options.hidden && item.options.Attrtypesign === '1')
			.map((itm) => ({
				label: itm.options.label,
				code: itm.options.code,
				type: itm.type,
				children: itm.children
					.filter((item) => !item.options.hidden && item.type !== 'placeholder')
					.map((it) => ({
						label: it.options.label,
						code: it.options.code,
						type: it.type,
						isKey: it.options.isKey,
						options: it.options,
					})),
			})),
	);

	const flatMoreSearchList = computed(() =>
		moreSearchList.value.reduce((arr, itm) => {
			return [...arr, ...itm.children];
		}, []),
	);

	// 获取关键属性字段并默认展示
	const isKeyList = computed(() =>
		moreSearchList.value
			.reduce((arr, itm) => {
				return [...arr, ...itm.children];
			}, [])
			.filter((itm) => itm.isKey === '1'),
	);

	// 默认全选
	const defaultExportList = computed(() =>
		moreSearchList.value.reduce((arr, itm) => {
			return [...arr, ...itm.children];
		}, []),
	);

	const getItem = (code) => flatMoreSearchList.value.find((itm) => itm.code === code);

	// table选中的行
	const selectIds = computed((): string[] =>
		resTable.value?.ref ? resTable.value.ref.getSelectionRows().map((itm) => itm.objectid) : [],
	);

	const resItem = computed(() => props.resItem);

	// watch
	watch(
		() => resItem.value,
		(newVal) => {
			// 点击某个配置项时获取他对应的表单模版
			newVal.objectid &&
				getModel({ ...props.params, objectid: newVal.objectid }).then((res) => {
					if (res.code === 200) {
						const data = res.data?.children || [];
						widgetDatas.value = data;
					}
				});
			setTimeout(() => (params1.value = { ...INIT_PARAMS(), resCode: newVal.resCode }));
		},
		{
			immediate: true,
		},
	);

	watch(
		() => params1.value,
		() => {
			getList();
		},
		{
			deep: true,
		},
	);

	const { loading: tableLoading, load: getTalbeList } = useRequest(getResObjectList);

	// actions
	const getList = async () => {
		if (params1.value.resCode) {
			const fieldMap = Object.assign({ ...params1.value.fieldMap } || {}, props.params?.fieldMap || {});
			const res = await getTalbeList({ ...props.params, ...params1.value, fieldMap });
			tableData.value = {
				total: res?.total || 0,
				data: res?.rows || [],
			};
			if (props.onlyOneOpenDetail && tableData.value.data.length === 1) {
				onClickItem('read', { row: tableData.value.data[0] });
			}
		}
	};

	const onSearch = (value) => {
		const obj = { ...value };
		delete obj.searchText;

		params1.value.resName = value.searchText;
		params1.value.fieldMap = obj;
	};

	//导出
	const onExport = (_list, callback: Function) => {
		const date = dayjs().format('YYYYMMDD');
		download(
			exportResObjectList(),
			{ ...props.params, ...params1.value },
			`${props.resItem.resName}-资源列表-${date}.xlsx`,
			{
				'Content-Type': 'application/json',
			},
		).then(() => {
			callback();
		});
	};

	const tableChange = (pagination) => {
		params1.value.pageNum = pagination.pageNum;
		params1.value.pageSize = pagination.pageSize;
	};

	const onDelete = async (delCallback: Function) => {
		const res = await delResObject({ ...props.params, deleteIds: selectIds.value });
		if (res.code === 200) {
			delCallback();
			saveCallback();
			ElMessage({
				message: '删除成功',
				type: 'success',
			});
		}
	};

	const onClickItem = async (type: Drawer['type'], item?: any) => {
		drawer.value = {
			type,
			item: item?.row || {},
		};
	};

	const onAdd = async (params, resolve, reject) => {
		const res = await addResObject({ ...props.params, ...params });
		if (res.code === 200) {
			resolve();
			saveCallback();
		} else {
			reject();
		}
	};

	const onEdit = async (params, resolve, reject) => {
		const res = await editResObject({ ...props.params, ...params });
		if (res.code === 200) {
			resolve();
			saveCallback();
		} else {
			reject();
		}
	};

	// 导入
	const importClick = () => {
		importVisible.value = true;
	};

	const onImport = async (param, callback: Function) => {
		const res = await importResource({
			...props.params,
			resCode: resItem.value.resCode,
			file: param.file,
		});
		callback();
		if (res.code === 200) {
			ElMessage({
				message: '导入成功',
				type: 'success',
			});
			saveCallback();
		}
		importVisible.value = false;
	};

	const onExportTemplate = () => {
		download(
			// 接口的路径 + 参数
			exportTemplate(),
			{
				...props.params,
				resCode: props.resItem.resCode,
			},
			//导出的名字
			`${props.resItem.resName}数据模版.xlsx`,
			// 覆盖headers请求头里边的Content-Type
			{ 'Content-Type': 'application/json' },
		);
	};

	const saveCallback = () => {
		getList();
		emits('callback');
	};

	const getBussinessDetail = async (code) => {
		const res = await getBussinessList({ code });
		const { relationCompute = '0', ifRecordHis = '0' } = res.rows[0] || {};
		resourceConfig.value = {
			relationCompute,
			ifRecordHis,
		};
	};

	props.params?.bussinessCode && getBussinessDetail(props.params?.bussinessCode);

	provide('resItem', resItem);
	provide('bussinessCode', props.params?.bussinessCode);

	defineExpose({ resTable, getList });
</script>

<style scoped lang="scss">
	.res-list {
		height: 100%;

		.res-list-table {
			width: 100%;
		}

		.header-right {
			.el-button + .el-button {
				margin-left: 0px;
			}
		}
	}
</style>
